module.exports = __webpack_public_path__ + "img/laura.55c8c2b0.png";